import { render, staticRenderFns } from "./BuildingShowLayoutSettingsTab.vue?vue&type=template&id=5a961f3c"
import script from "./BuildingShowLayoutSettingsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowLayoutSettingsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports